window.onload = function(){
  let head_right = document.querySelector("header hdt-sticky-header > div.hdt-main-header.hdt-s-gradient > div > div > div.lg\\:hdt-custom-col-4.md\\:hdt-custom-col-4.hdt-custom-col-3 > div");
  let head_info = document.createElement("div");
  head_info.className = "hdt-flex hdt-align-center hdt-head-info"
  head_info.style.gap = "18px";
  head_info.innerHTML = `
    <div class="hdt-icon">
    <a href="tel:0395094041">
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewbox="0 0 28 28" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.21989 13.7008C2.19942 13.7199 2.18295 13.743 2.17143 13.7685C2.1599 13.7941 2.15354 13.8217 2.15272 13.8497V18.5857C2.15272 19.4124 2.83298 20.0926 3.65962 20.0926H5.5256C5.64874 20.0926 5.74087 20.0005 5.74087 19.8774V13.8497C5.73977 13.793 5.71674 13.7389 5.6766 13.6987C5.63647 13.6586 5.58235 13.6356 5.5256 13.6345H2.36799C2.3118 13.6361 2.25855 13.66 2.21989 13.7008ZM0 13.8497C0.00339224 13.2228 0.253966 12.6224 0.697317 12.1791C1.14067 11.7357 1.74101 11.4851 2.36799 11.4817H5.5256C6.15335 11.4827 6.75513 11.7324 7.19902 12.1763C7.64291 12.6202 7.89268 13.222 7.89359 13.8497V19.8774C7.89428 20.1885 7.83349 20.4967 7.71473 20.7844C7.59597 21.072 7.42157 21.3333 7.20154 21.5533C6.98152 21.7733 6.7202 21.9477 6.4326 22.0665C6.14499 22.1852 5.83676 22.246 5.5256 22.2453H3.65962C1.64468 22.2453 0 20.6007 0 18.5857V13.8497Z" fill="white"></path>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9927 2.15272C12.8144 2.1517 11.6476 2.38302 10.5588 2.83344C9.47008 3.28386 8.48083 3.94455 7.64769 4.77769C6.81455 5.61083 6.15387 6.60007 5.70345 7.68882C5.25303 8.77756 5.02171 9.94444 5.02273 11.1227V12.5719C5.02273 12.8574 4.90933 13.1311 4.70747 13.333C4.50561 13.5348 4.23184 13.6482 3.94637 13.6482C3.6609 13.6482 3.38712 13.5348 3.18527 13.333C2.98341 13.1311 2.87001 12.8574 2.87001 12.5719V11.1227C2.87001 4.97451 7.84451 0 13.9927 0C20.1409 0 25.1154 4.97451 25.1154 11.1227V12.5581C25.1154 12.8436 25.002 13.1174 24.8001 13.3192C24.5982 13.5211 24.3245 13.6345 24.039 13.6345C23.7535 13.6345 23.4798 13.5211 23.2779 13.3192C23.076 13.1174 22.9626 12.8436 22.9626 12.5581V11.1227C22.9626 6.16281 18.9525 2.15272 13.9927 2.15272ZM24.107 20.1133C24.2457 20.1411 24.3775 20.1959 24.495 20.2746C24.6124 20.3534 24.7132 20.4545 24.7916 20.5722C24.87 20.6899 24.9244 20.8219 24.9517 20.9607C24.979 21.0994 24.9788 21.2422 24.9509 21.3808C24.1914 25.1601 20.859 28 16.8627 28H15.4281C15.1426 28 14.8689 27.8866 14.667 27.6847C14.4652 27.4829 14.3518 27.2091 14.3518 26.9236C14.3518 26.6382 14.4652 26.3644 14.667 26.1625C14.8689 25.9607 15.1426 25.8473 15.4281 25.8473H16.8627C18.2705 25.8473 19.635 25.3603 20.7245 24.4688C21.8141 23.5773 22.5617 22.3362 22.8404 20.9563C22.8967 20.6766 23.0617 20.4307 23.2992 20.2726C23.5367 20.1146 23.8273 20.0572 24.107 20.1133Z" fill="white"></path>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3117 13.7008C22.2912 13.7199 22.2747 13.743 22.2632 13.7685C22.2517 13.7941 22.2453 13.8217 22.2445 13.8497V19.8774C22.2445 19.9936 22.3444 20.0926 22.4598 20.0926H24.2543C25.124 20.0926 25.8326 19.3831 25.8326 18.5134V13.8497C25.8315 13.793 25.8085 13.7389 25.7684 13.6987C25.7282 13.6586 25.6741 13.6356 25.6174 13.6345H22.4598C22.4036 13.6361 22.3503 13.66 22.3117 13.7008ZM20.0918 13.8497C20.0952 13.2228 20.3457 12.6224 20.7891 12.1791C21.2324 11.7357 21.8328 11.4851 22.4598 11.4817H25.6174C26.2451 11.4827 26.8469 11.7324 27.2908 12.1763C27.7347 12.6202 27.9845 13.222 27.9854 13.8497V18.5134C27.9847 19.5028 27.5914 20.4515 26.8918 21.1512C26.1923 21.8509 25.2437 22.2444 24.2543 22.2453H22.4598C21.832 22.2444 21.2302 21.9947 20.7863 21.5508C20.3425 21.1069 20.0927 20.5051 20.0918 19.8774V13.8497Z" fill="white"></path>
    </svg>
    </a>
    </div>
    <div class="hdt-number hdt-flex hdt-flex-col">
    <a href="tel:0395094041" style=" font-size:34px; font-weight:700; color:rgb(var(--color-accent)); line-height:28px;line-height: 4rem;"> (03) 9509 4041</a>
    <span style=" font-size:13px; font-weight:500;color: rgb(var(--color-foreground));line-height: 15px;">Call Us Today</span>
    <span style=" font-size:14px; font-weight:500;color: rgb(var(--color-foreground))"><a href="mailto:enquiries@kiddlecountry.com.au">enquiries@kiddlecountry.com.au</a></span>
    </div>
  `
  head_right.insertBefore(head_info,head_right.querySelector(".hdt-inline-flex.hdt-align-center.hdt-site-nav_icon"))
  
  if(window.location.href.indexOf("/products")!=-1){
    // Product Page footer section
    let missDom = document.querySelector("body > div.cbb-also-bought-container.cbb-desktop-view");
    if(missDom){
      let main = document.querySelector("main.content-for-layout");
      main.appendChild(missDom);
    }
  }



  
  
  // Function to update the pre-order message
  function updateOrderMsg() {
    // Find the fieldset where you want to insert the message after
    const quantitySelector = document.querySelector('.hdt-product-info__list div[data-type="quantity_selector"]');
    const iconSVG = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" aria-hidden="true" class="bi bi-check-circle-fill" viewBox="0 0 16 16" >
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
      </svg>
    `;
    
    let msgDiv = document.querySelector('.hdt-product-info__list #order-msg')
    if(!msgDiv){
      msgDiv = document.createElement('div');
      msgDiv.id = 'order-msg';
      // Insert the message container before the quantitySelector
      quantitySelector && quantitySelector.parentNode.insertBefore(msgDiv, quantitySelector);
    }
    
    const checked = document.querySelector('.hdt-product-info__list hdt-variant-picker input:checked');
    // if (!checked) return;

    const val = checked ? checked.value : '';
    const dueMatch = val.match(/\(due ([^)]+)\)/);

    if (dueMatch) {
      msgDiv.innerHTML = iconSVG + `Pre-order Today & Get it in ${dueMatch[1]}`;
    } else {
      msgDiv.innerHTML = iconSVG + 'Available for Order';
    }
    console.log('1')
  }
  
  // Initialize message on load
  updateOrderMsg();

  // Attach event listeners to all radio buttons
  const variantPickerButtonsListener = ()=>{
    const variantPickerButtons = document.querySelectorAll('hdt-variant-picker input')
    variantPickerButtons && variantPickerButtons.forEach(input => {
      input.addEventListener('change', updateOrderMsg);
    });
  }
  variantPickerButtonsListener()


  // Select all buttons by class name
  const quickViewButtons = document.querySelectorAll('.hdt-card-product__btn-quick-view');
  // Attach the event listener to each button
  quickViewButtons && quickViewButtons.forEach(function(button) {
    button.addEventListener('click', ()=>setTimeout(()=>{
      updateOrderMsg();
      variantPickerButtonsListener();
    },2000));
  });

}